const MGTTAdminConfigKeys = {
  TITLE: "Clogs Config",
  CONFIG_FOR: "Config for",
  CONFIG_VALUE1: "Config Value 1",
  CONFIG_VALUE2: "Config Value 2",
  CONFIG_VALUE3: "Config Value 3",
  CONFIG_DESCRIPTION: "Config Description",
  MODULE_NAME: "Module Name",
  CLOGS_ADMIN: "CLOGS Admin"
}

export default MGTTAdminConfigKeys
